import React from 'react'
import convertUnit from 'lib/unit'
import styled from 'styled-components'
import {Icon} from '../Icon'

const StyledPackage = styled.div`
  width: ${convertUnit(64)};
  height: ${convertUnit(64)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.info_1};
  border-radius: ${convertUnit(8)};
`

export default function PackageIcon() {
  return (
    <StyledPackage>
      <Icon type="collection" color="primary_5" />
    </StyledPackage>
  )
}
